import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Modal } from "bootstrap";
import { useForm, Controller, } from "react-hook-form";
import Select from "react-select";
import * as caseService from "../../Services/caseService"
import { toast } from "react-toastify";


const B2BBulkCaseAssign = forwardRef((props, ref) => {
    const { selectedCases, setSelectedCases, getCaseData } = props;
    const { control, handleSubmit, reset, setValue, formState: { errors }, } = useForm({ mode: "onSubmit", });
    const modalRef = useRef(null);
    const bsModal = useRef(null);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [departmentTypeOptions, setdepartmentTypeOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);

    const handleClose = () => {
        reset();
        bsModal.current?.hide();
    }

    useImperativeHandle(ref, () => ({

        toggle(caseIds) {

            // Single case
            if (caseIds !== undefined && caseIds !== null) {

                if (Array.isArray(caseIds)) {
                    setSelectedCases(caseIds);
                } else {
                    setSelectedCases([Number(caseIds)]);
                }
            }

            if (!bsModal.current) {
                bsModal.current = new Modal(modalRef.current);
            }

            bsModal.current.show();
        },

        close() {
            handleClose();
        },

    }));

    useEffect(() => {
        getDepartment();
    }, [])

    const getDepartment = () => {
        caseService.department().then((res) => {
            const data = res?.data?.data || []
            const formattedOptions =
                data.map((item) => ({
                    label: item?.name?.trim(),
                    value: item?.id,
                }));
            setdepartmentTypeOptions(
                formattedOptions
            );
        }).catch((errro) => {

        })
    }

    const getallEmoloyee = (department) => {

        if (!department) {
            setEmployeeOptions([]);
            return;
        }

        caseService
            .employeeAccordingtodepartment(department)
            .then((res) => {

                const data = res?.data?.data || [];

                const formattedOptions = data.map((item) => ({
                    label: item?.name?.trim(),
                    value: item?.id,
                }));

                setEmployeeOptions(formattedOptions);
            })
            .catch((error) => {
                // console.log("Employee error:", error);
                setEmployeeOptions([]);
            });
    };

    const onSubmit = async (data) => {
        try {
            setSubmitLoader(true);

            const payload = {
                caseId: selectedCases,
                empIds: data.employee?.value
            };

            const res = await caseService.b2bassignedemp(payload);

            if (res?.data?.status === "success") {

                toast.success(
                    res?.data?.message || "Cases assigned successfully."
                );

                setSelectedCases([]);

                if (props.getCaseData) {
                    props.getCaseData();
                }

                handleClose();

            } else {

                const skipped = res?.data?.skipped || [];

                const errorMessage =
                    skipped.length > 0
                        ? skipped[0]?.reason
                        : res?.data?.message || "No cases were assigned.";

                toast.error(errorMessage);
            }

        } catch (error) {

            const response = error?.response?.data;

            const skipped = response?.skipped || [];

            const errorMessage =
                skipped.length > 0
                    ? skipped[0]?.reason
                    : response?.message ||
                    response?.error ||
                    "Something went wrong while assigning cases.";

            toast.error(errorMessage);

        } finally {
            setSubmitLoader(false);
        }
    };
    return (
        <div
            className="modal fade" ref={modalRef} tabIndex="-1" aria-hidden="true" style={{ background: "rgba(15,23,42,0.55)", backdropFilter: "blur(5px)", }}
        >
            <div className="modal-dialog modal-lg modal-dialog-centered " style={{ maxWidth: "95vw", width: "95vw", margin: "10px auto", }}>
                <div className="modal-content border-0 rounded-4" style={{ width: "100%", }}>
                    <div className="modal-header border-0 text-white" style={{ background: "linear-gradient(135deg,#2563eb,#1d4ed8)", }}>
                        <div className="">
                            <p className="mb-0 small opacity-75">
                                Assign Cases
                            </p>
                        </div>
                        <button className="btn btn-light rounded-circle position-absolute" type="button" style={{ top: "10px", right: "18px", width: "38px", height: "38px", }} onClick={handleClose}>
                            <i className="fa fa-times"></i>
                        </button>



                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body p-4">
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Department<span className="text-danger ms-1">*</span></label>
                                    <Controller
                                        name="department"
                                        control={control}
                                        rules={{
                                            required: "Please select atleast one department",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                classNamePrefix="react-select"
                                                options={departmentTypeOptions}
                                                placeholder="Select Department"
                                                isClearable
                                                isSearchable
                                                value={field.value || null}
                                                onChange={(selected) => {

                                                    field.onChange(selected);

                                                    if (!selected) {
                                                        setValue("employee", null);
                                                        setEmployeeOptions([]);
                                                        return;
                                                    }

                                                    getallEmoloyee(selected?.label || "");
                                                }}
                                            />
                                        )}
                                    />


                                    {errors.department && (

                                        <small className="text-danger fw-semibold">

                                            {
                                                errors
                                                    .department
                                                    .message
                                            }

                                        </small>

                                    )}
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Employee <span className="text-danger ms-1">*</span></label>
                                    <Controller
                                        name="employee"
                                        control={control}
                                        rules={{
                                            required: "Please select atleast one employee",
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={employeeOptions}
                                                placeholder="Select Employee"
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={field.value || null}
                                                isClearable
                                                isSearchable
                                            />
                                        )}
                                    />
                                    {errors.employee && (

                                        <small className="text-danger fw-semibold">

                                            {
                                                errors
                                                    .employee
                                                    .message
                                            }

                                        </small>

                                    )}
                                </div>
                            </div>

                        </div>

                        <div className="modal-footer border-0 px-4 pb-4">
                            <button className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold" type="button" onClick={handleClose}>
                                Close

                            </button>
                            <button
                                type="submit"
                                className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                disabled={
                                    submitLoader
                                }
                            >

                                {submitLoader
                                    ? "Updating..."
                                    : "Update"}

                            </button>

                        </div>


                    </form>

                </div>

            </div>

        </div>
    )
})

export default B2BBulkCaseAssign;